export const stringHeaderMain = {
    headTitle : "Jadwal SIAKNG Generator",
    headDesc : "Website ini akan mengubah SS SIAKNG menjadi JSON dan .ICS file.",
    headLink : "About",
    link: "/about"
}

export const stringHeaderAbout = {
    headTitle : "About Jadwal SIAKNG Generator",
    headDesc : "Tutorial menggunakan website ini",
    headLink : "Home",
    link: "/"
}